import { ChangeDetectionStrategy, Component } from "@angular/core";
import { CustomRenderer, ElementInstance } from "@husbanken/rzrforms-lib";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "custom-comp-link",
  template: `<a class="hb-button hb-button--link hb-mb--lg"
                data-e2e-selector="tipsButton"
                [routerLink]="'/veiledning'"
                (click)="navigateToVeiledning()"
                translate>Få tips til hvordan du laster opp filer</a>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLink,
    TranslateModule
  ]
})
export class LinkComponent extends CustomRenderer<any, ElementInstance> {
  uuid = "";

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    const urlParams = new URLSearchParams(window.location.search);
    this.uuid = urlParams.get('uuid');
  }

  protected navigateToVeiledning() {
    this.router.navigate(['veiledning'], {relativeTo: this.activatedRoute, queryParamsHandling: "merge"});
  }
}
